import { useEffect } from 'react';
import axios, { AxiosRequestConfig } from 'axios';

const useFilesUpload = () => {
	useEffect(() => {
		const fileUploadId = axios.interceptors.request.use((config: AxiosRequestConfig) => {
			if (!config.data || typeof config.data !== "object" || !config.data.files) return config;

			const data: Record<string, any> = {};
			const formData = new FormData();

			for (const key in config.data) {
				const element = config.data[key];
				if (element instanceof File) {
					formData.append('FilesHandler', element, key);
				} else {
					data[key] = element;
				}
			}

			formData.append('data', JSON.stringify(data));
			config.data = formData;

			return config;
		});

		return () => {
			axios.interceptors.request.eject(fileUploadId);
		}
	}, []);
}

export default useFilesUpload;